import React, { useEffect, useRef, useState } from "react";
import CompanyTab from "./CompanyTab";
import MyProfileTab from "./MyProfileTab";
import BankLinkTab from "./BankLinkTab";
import { getUser, updateUser } from "../../../action/userAction";
import { showMessage } from "../../../utils/toast/globalToast";
import { _toastVariants } from "../../../utils/Constant";



const CompanyProfile = () => {

    const companyFormRef = useRef();
    const profileFormRef = useRef();
    const [activeTab, setActiveTab] = useState("company");
    const [user, setUser] = useState({});
    const [company, setCompany] = useState({});
    const [bank, setBank] = useState({});

    const fetchUser = async () => {
      try {
        const res = await getUser(); 
        if (res?.success && res?.data) {
          const userData = res.data; 

          setUser({
            _id: userData._id,
            userName: userData.userName,
            email: userData.email,
            mobileNo: userData.mobileNo,
            profilePic: userData.profilePic,
          });

          setCompany({
            name: userData.businessInfo?.name || "",
            logo: userData.businessInfo?.logo || "",
            location: userData.businessInfo?.location || {},
            documents: userData.businessInfo?.documents || [],
            idProof: userData.businessInfo?.idProof || [],
          });

          setBank({
            linked: userData.stripe?.linked || false,
            accountId: userData.stripe?.accountId || "",
          });
        } else {
          console.warn("No valid user data found in response");
        }

      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

  const handleSubmit = async () => {
      try {
        let payload = null;

        if (activeTab === "company" && companyFormRef.current) {
          const companyData = await companyFormRef.current.submitForm();
          payload = companyData;
        }

        if (activeTab === "profile" && profileFormRef.current) {
          const profileData = await profileFormRef.current.submitForm();
          payload = profileData;
        }

        if (payload) {
          const result = await updateUser(user?._id, payload);

          if (result.success) {
            console.log("Update successful:", result.data);
            showMessage(result.message, _toastVariants.Success);
          } else {
            console.log("Update failed:", result.error);
            showMessage(result.error, _toastVariants.Error);
          }
        } else {
          console.warn("No form data found to submit");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        showMessage("Something went wrong while submitting the form.", _toastVariants.Error);
      }
    };


    useEffect(()=>{
      fetchUser()
    },[])


  return (
    <section className="content mb-5">
      <div className="container-fluid">
        {/* Header */}
        <div className="row titlepad publsih-sticky">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <h4>Company / My Profile</h4>
                <p className="page-sub-head">
                  Add or update the information below
                </p>
              </div>
              <div className="col-md-4 text-sm-right mt-2">
                {/* ✅ Match this ID with form ID below */}
                <button
                  type="submit"
                  form="companyProfileForm"
                  className="btn-md px-3 py-2 btn-primary"
                  onClick={handleSubmit}
                >
                 Save
                </button>
                {/* <a
                  href="javascript:history.back()"
                  className="btn-md px-3 py-2 btn-secondary"
                >
                  <i className="fa fa-chevron-circle-left"></i> Cancel
                </a> */}
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="row">
          <div className="col-md-12">
            <div className="loginTabs mt-0 w-100 pr-0 mb-0">
           <ul className="nav nav-tabs nav-fill" id="myTab" role="tablist">
            <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "company" ? "active" : ""}`}
                  id="company-tab"
                  href="#company"
                  role="tab"
                  onClick={() => setActiveTab("company")}
                >
                  Company Profile
                </a>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
                  id="profile-tab"
                  href="#profile"
                  role="tab"
                  onClick={() => setActiveTab("profile")}
                >
                  My Profile
                </a>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "bank" ? "active" : ""}`}
                  id="bank-tab"
                  href="#bank"
                  role="tab"
                  onClick={() => setActiveTab("bank")}
                >
                  Bank Link
                </a>
              </li>
          </ul>

            </div>

            <div className="tab-content" id="myTabContent">
             <div
                  className={`tab-pane fade ${activeTab === "company" ? "show active" : ""}`}
                  id="company"
                >
                  <CompanyTab ref={companyFormRef} company={company} />
                </div>

                <div
                  className={`tab-pane fade ${activeTab === "profile" ? "show active" : ""}`}
                  id="profile"
                >
                  <MyProfileTab ref={profileFormRef} user={user} />
                </div>

                <div
                  className={`tab-pane fade ${activeTab === "bank" ? "show active" : ""}`}
                  id="bank"
                >
                  <BankLinkTab bankData={bank} />
                </div>

              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyProfile;
